import { OrderedEnumerable } from "../OrderedEnumerable.js";
export const order = (source, comparer) => {
    return OrderedEnumerable.generate(source, (x) => x, true, comparer);
};
